/* I13D in DS */
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ArrowDown: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.29289 10.7071L11.2426 15.6569C11.6332 16.0474 12.2663 16.0474 12.6569 15.6569L17.6066 10.7071C17.9971 10.3166 17.9971 9.68342 17.6066 9.29289C17.2161 8.90237 16.5829 8.90237 16.1924 9.29289L11.949 13.535L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071Z"
        />
      </svg>
    </IconWrap>
  );
};
ArrowDown.displayName = 'ArrowDown';

export default ArrowDown;
